





























import * as Routes from '@/browser/routes';
import { BindAsList } from '../decorators/dao';
import { Component, Prop, Vue } from 'vue-property-decorator';
import ChangelogDialog from '@/browser/moleculers/ChangelogDialog.vue';
import FeedbackDialog from '@/browser/moleculers/FeedbackDialog.vue';
import Loading from '@/browser/atoms/Loading.vue';
import Room, { RoomAddData } from '@/models/Room';
import RoomCreateDialog from '@/browser/components/RoomCreateDialog.vue';
import RoomList from '@/browser/moleculers/RoomList.vue';
import RoomsDAO from '../dao/RoomsDAO';
import config from '../config';

const roomsDAO = new RoomsDAO();

@Component({
  components: {
    ChangelogDialog,
    FeedbackDialog,
    Loading,
    RoomCreateDialog,
    RoomList,
  },
})
export default class LobbyPage extends Vue {
  @BindAsList(roomsDAO, true) rooms!: Room[] | null;
  cdOpen: boolean = false;
  fdOpen: boolean = false;

  get title() {
    return config.title;
  }

  async createRoom(room: RoomAddData) {
    const roomId = await roomsDAO.addItem(room);
    this.$router.push({ name: Routes.Room.name, params: { roomId } });
  }

  created() {
    document.title = this.title;
  }
}
